import classnames from 'classnames';
import includes from 'lodash/includes';
import { arrayOf, bool, func, object, oneOf, shape, string } from 'prop-types';
import { Component } from 'react';

import Tabs from 'shared/components/tabs/Tabs';

import Loader from '../loader/Loader';
import ArchiveItem from './archive/ArchiveItem';
import ArchiveUpload from './archive/ArchiveUpload';
import ArchiveWarning from './archive/ArchiveWarning';
import ConfirmDelete from './archive/ConfirmDelete';

export default class ArchiveDialog extends Component {
  static propTypes = {
    activeBetItem: object,
    bodyText: string,
    categories: arrayOf(
      shape({
        id: string.isRequired,
        type: oneOf(['bet', 'template']).isRequired,
        menuText: string.isRequired,
      }),
    ).isRequired,
    closeHandler: func.isRequired,
    confirmDeleteText: string.isRequired,
    emptyText: string.isRequired,
    isLoading: bool.isRequired,
    items: arrayOf(object).isRequired,
    markedForDeletion: arrayOf(object).isRequired,
    onConfirmDeleteClick: func,
    onCancelDeleteClick: func,
    onDeleteItemClick: func,
    onFileUploaded: func,
    onDuplicateItemClick: func,
    onEditItemClick: func,
    onMenuClick: func.isRequired,
    onOpenItemClick: func,
    renderItemBox: func,
    renderItemInfo: func.isRequired,
    selectedCategory: string.isRequired,
  };

  state = {
    isMenuExpanded: false,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.selectedCategory !== nextProps.selectedCategory) {
      this.setState({ isMenuExpanded: false });
    }
  }

  toggleMenu = () =>
    this.setState({
      isMenuExpanded: !this.state.isMenuExpanded,
    });

  render() {
    const { isMenuExpanded } = this.state;

    const {
      closeHandler,
      isLoading,
      selectedCategory,
      categories,
      items,
      activeBetItem,
      bodyText,
      emptyText,
      confirmDeleteText,
      renderItemBox,
      renderItemInfo,
      markedForDeletion,
      onMenuClick,
      onOpenItemClick,
      onEditItemClick,
      onDuplicateItemClick,
      onDeleteItemClick,
      onConfirmDeleteClick,
      onCancelDeleteClick,
      onFileUploaded,
    } = this.props;

    const { id, type } = categories.find(
      category => category.id === selectedCategory,
    );

    const hasItems = items.length > 0;
    const downloadEnabled =
      categories.some(({ id }) => id === 'uploadedBets') &&
      selectedCategory !== 'templates';

    return (
      <div className={classnames({ 'mobile-menu-active': isMenuExpanded })}>
        {markedForDeletion.length === 0 && (
          <Tabs
            items={categories}
            selectedId={id}
            showExpanded={isMenuExpanded}
            closeHandler={closeHandler}
            clickHandler={onMenuClick}
            toggleHandler={this.toggleMenu}
          />
        )}
        {markedForDeletion.length > 0 && (
          <ConfirmDelete
            confirmHandler={onConfirmDeleteClick}
            cancelHandler={onCancelDeleteClick}
            label={confirmDeleteText}
          />
        )}

        <Loader visible={isLoading} backgroundAlpha="light" cover />

        <div className="archive-dialog-body">
          {bodyText && hasItems && (
            <div className="archive-dialog-body-text">{bodyText}</div>
          )}
          {id === 'uploadedBets' && (
            <ArchiveUpload onFileUploaded={onFileUploaded} />
          )}
          {(id === 'futureBets' || id === 'pastBets') && downloadEnabled && (
            <ArchiveWarning />
          )}
          <div className="list-container">
            {items.map((item, idx) => (
              <ArchiveItem
                key={idx}
                item={item}
                type={type}
                isCurrent={item === activeBetItem}
                isSelectedForDelection={includes(markedForDeletion, item)}
                downloadEnabled={downloadEnabled}
                renderItemBox={renderItemBox}
                renderItemInfo={renderItemInfo}
                editHandler={onEditItemClick}
                openHandler={onOpenItemClick}
                duplicateHandler={onDuplicateItemClick}
                deleteHandler={onDeleteItemClick}
              />
            ))}
            {!hasItems && <div className="empty">{emptyText}</div>}
          </div>
        </div>
      </div>
    );
  }
}
